import * as React from 'react'

const CopyLink: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width={19} height={18} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.17 8.471c.85-.85 2.331-.85 3.181 0a.75.75 0 1 0 1.06-1.06 3.724 3.724 0 0 0-2.65-1.1c-1.003 0-1.945.392-2.652 1.1L4.518 9a3.756 3.756 0 0 0 0 5.304 3.738 3.738 0 0 0 2.65 1.096c.962 0 1.922-.365 2.653-1.096a.75.75 0 0 0-1.06-1.06 2.255 2.255 0 0 1-3.183 0 2.254 2.254 0 0 1 0-3.183l1.592-1.59Z"
      fill="currentColor"
    />
    <path
      d="M9.82 3.698a.75.75 0 0 0 1.061 1.06 2.255 2.255 0 0 1 3.183 0 2.254 2.254 0 0 1 0 3.183l-1.592 1.59c-.85.85-2.332.85-3.181 0a.75.75 0 1 0-1.06 1.061 3.724 3.724 0 0 0 2.65 1.099c1.002 0 1.944-.39 2.652-1.099l1.591-1.59a3.756 3.756 0 0 0 0-5.304 3.754 3.754 0 0 0-5.303 0Z"
      fill="currentColor"
    />
  </svg>
)

export default CopyLink
